import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import Multiselect from './components/Multiselect'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { Button, Stack } from '@mui/material'
import { useParams } from 'react-router-dom'

const CreateModal = ({ handleRefresh, awards, questions, category }) => {
  const uploadImage = useUploadImage()
  const [agency] = useAgencyInfo()
  const { chapter_id, type } = useParams()

  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)

  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    const formData = new FormData(e.target)
    const answerValue = formData.get('answer') === 'true'
    let image_response
    if (e.target?.image?.files?.[0]) {
      image_response = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      })
    }

    const payload = {
      chapter_id: type,
      question: e.target.question.value,
      answer: answerValue,
      priority: e.target.priority.value,
      points: e.target.points.value,
      image: image_response?.response.data ? image_response?.response.data : '',
      type: chapter_id,
      status: e.target.status.value,
    }
    const { response } = await AppService.questions_chapters.create({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    }
  }

  const handleCsvUpload = async (e) => {
    e.preventDefault()
    const fileInput = e.target
    const file = fileInput.files[0]

    if (!file) {
      alert('Please select a file')
      return
    }

    const formData = new FormData()
    formData.append('csvFile', file)
    formData.append('agency_id', agency._id)

    setProcessing(true)
    const response = await AppService.questions_chapters.uploadCsv({ payload: formData })

    if (response) {
      fileInput.value = '' // Reset file input
      alert('CSV uploaded successfully!') // Show success alert
      handleRefresh()
    }
    setProcessing(false)
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
        <MDButton color="white" variant="contained" onClick={handleModal}>
          Create
        </MDButton>
        <input
          type="file"
          accept=".csv"
          onChange={handleCsvUpload}
          style={{ display: 'none' }}
          id="csv-upload"
        />
        <label htmlFor="csv-upload">
          {/* <MDButton color="white" variant="contained" component="span" disabled={processing}>
            Upload CSV
          </MDButton> */}
        </label>
      </div>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Question Chapters
            </MDTypography>

            {/* <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                select
                name="chapter_id"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select a chapter</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.chapter_name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}

            <MDBox mb={2}>
              <MDTypography variant="button">Question</MDTypography>
              <MDInput label="Question" name="question" fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Answer</MDTypography>
              <FormControl fullWidth>
                <InputLabel>Answer</InputLabel>
                <Select name="answer" defaultValue="">
                  <MenuItem value="true">True</MenuItem>
                  <MenuItem value="false">False</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Point Number</MDTypography>
              <MDInput label="Point Number" name="points" fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">priority</MDTypography>
              <MDInput label="priority" name="priority" fullWidth required />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="User">User</option>
                <option value="Location">Location</option>
                <option value="Agency">Agency</option>

              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput select name="status" fullWidth required SelectProps={{ native: true }}
              defaultValue="Publish"
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
